<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getLocaleColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
        :hide-default-footer="!!productUid"
    >
      <template v-slot:top v-if="!productUid">
        <v-toolbar ref="RefListTop" height="128">
          <v-text-field
              v-model="searchTerm"
              :label="$t('search') + '*'"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field type="date" v-model="filtersArg.date_from" clearable :label="$t('from_delivery_date')"
                        @input="onUpdateFilters"></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field type="date" v-model="filtersArg.date_to" clearable :label="$t('to_delivery_date')"
                        @input="onUpdateFilters"></v-text-field>
        </v-toolbar>

      </template>
      <template v-slot:item.delivery_date="{ item }">
        <router-link :to="{name:'BatchRunItem', params: { itemUid: item.uid}}">
          <span v-if="item.calendar_date.dt">{{ item.calendar_date.dt | moment("DD.MM.YYYY") }}</span>
          <span v-else="item.calendar_date.dt">****</span>
        </router-link>
      </template>
      <template v-slot:item.customer_order_title="{ item }">
        <router-link :to="{name:'CustomerOrderItem', params: { itemUid: item.customer_order_uid}}">
          <span v-if="item.customer_order_title">{{ item.customer_order_title }}</span>
          <span v-else>****</span>
        </router-link>
      </template>
      <template v-slot:item.customer_title="{ item }">
        <router-link :to="{name:'CustomerItem', params: { itemUid: item.customer_uid}}">
          <span v-if="item.customer_title">{{ item.customer_title }}</span>
          <span v-else>****</span>
        </router-link>
      </template>
      <template v-slot:item.created_on="{ item }">
        <span v-if="item.created_on">{{ item.created_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.edited_on="{ item }">
        <span v-if="item.edited_on">{{ item.edited_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.created_by="{ item }">
        <span v-if="item.created_by">{{ item.created_by.username }}</span>
      </template>
      <template v-slot:item.editor_by="{ item }">
        <span v-if="item.editor_by">{{ item.editor_by.username }}</span>
      </template>
    </v-data-table>
    <ConfirmDialog :confirm_request="confirm_request" :fetch-request="fetchRequest"></ConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import ConfirmDialog from "@/components/Base/ConfirmDialog";

export default {
  name: 'BatchRunTable',
  props: {
    subtractHeight: {type: [Number], default: 210},
    height: {type: [Number], default: window.innerHeight},
    dto_model: {type: [String], default: 'DeliveryBrListQueryDTO'},
    productUid: {type: [String], default: null},
  },

  components: {
    ConfirmDialog,
  },

  computed: {
    ...mapGetters('BatchRunTable', ['getColumns', 'getStatusCustomerOrder']),
    ...mapFields('BatchRunTable', ['message_error', 'options', 'totalRecords', 'options.page', 'itemList',
      'loading', 'selectedItemList', 'searchTermFile', 'searchTerm', 'filters', 'errorMessage', 'filtersArg',
      'confirm_request', 'statusCustomerOrder',]),

    getLocaleColumns() {
      let columns = []
      let filteredColumn = this.getColumns.filter(row => row.brief === true || this.productUid === null)
      for (let column of filteredColumn) {
        let text = this.$t('columns.' + column.value)
        // console.log('text', text)
        if (!!text)
          column.text = text
        columns.push(column)
      }
      return columns
    },
  },

  methods: {
    ...mapActions('BatchRunTable', ['openWebSocket', 'fetchItemList', 'fetchItem',
      'fetchSaveItem', 'fetchActionSelectedItem', 'fetchAction', 'fetchRequest']),

    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },

    itemRowBackground: function (item) {
      // console.log('itemRowBackground', this.statusCustomerOrder, item)
      // let result = this.statusCustomerOrder.filter(row => row.name === item.status)
      // if (result.length > 0)
      //   return result[0].color
      return null
    },

    updateOptions() {
      console.log('updateOptions')
      this.onUpdateFilters()
    },

    onUpdateFilters() {
      console.log('onUpdateOptions')
      this.options.page = 1

      this.filters = []
      if (!!this.productUid)
        this.filters.push({param_compare: 'customer_order__variant__uid', value: this.productUid})
      if (this.filtersArg.date_from)
        this.filters.push({param_compare: 'calendar_date__dt__gte', value: this.filtersArg.date_from})
      if (this.filtersArg.date_to)
        this.filters.push({param_compare: 'calendar_date__dt__lte', value: this.filtersArg.date_to})

      this.fetchItemList(this.dto_model)
    },

    onUpdateSearchTerm: debounce(function () {
      console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList(this.dto_model)
    }, 800),

    getNotionLink(notion_id) {
      return 'https://www.notion.so/' + notion_id.replace(/-/g, '')
    }
  },

  async mounted() {
    console.log('mounted BatchRunTable')
    // this.searchTerm = null
  },

  created() {
  },
  destroyed() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.status_production {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.status_completely_delivered, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child {
  background-color: #FFF8E1 !important;
}

/*.status_production {*/
/*  background-color: #FFEBEE !important;*/
/*}*/

</style>

<i18n src="..\CustomerOrder\locales.json">
</i18n>
